import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=6b599dd6&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=6b599dd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b599dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b599dd6')) {
      api.createRecord('6b599dd6', component.options)
    } else {
      api.reload('6b599dd6', component.options)
    }
    module.hot.accept("./goodsInfo.vue?vue&type=template&id=6b599dd6&scoped=true", function () {
      api.rerender('6b599dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/correct/components/goodsInfo.vue"
export default component.exports